import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class FeedBack extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };
    }
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    request() {
        if (!localStorage.getItem('info')) {
            return (
                <div>
                    <div className="use_request_button category-right shadow-text shadow-button" onClick={this.toggle.bind(this)}>
                        <div className="seller_button" >
                            リクエストを投稿する
                        </div>
                    </div>
                    {/* <Button className="btn btn-success ml-5 mb-3" style={{ width: '150px' }} onClick={this.toggle.bind(this)}>リクエストを投稿する</Button> */}
                    <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} className={this.props.className}>
                        <ModalHeader toggle={this.toggle.bind(this)}></ModalHeader>
                        <ModalBody>
                            ログインしてください。
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={this.toggle.bind(this)}>閉じる</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )
        } else {
            return (
                <Link to={"/request"} style={{ textDecoration: 'none' }}>
                    <div className="use_request_button category-right shadow-text shadow-button">
                        <div className="seller_button" >
                            リクエストを投稿する
                        </div>
                    </div>
                </Link>
            )
        }
    }

    render() {
        return (
            <div className="massage_box" >
                <div className="feedback_box" style={{paddingLeft: "0px", paddingRight: "0px"}}>
                    <div className="">
                        <div className="shadow-text">
                            <Link to={"/transaction-flow"} style={{ textDecoration: 'none' }}>
                                <div className="use_request_button category-right shadow-button" >
                                    <div className="seller_button" >
                                        初めてガイド
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    {this.request()}
                    <div className="">
                        <div className="shadow-text">
                            <Link to={"/contact-us"} style={{ textDecoration: 'none' }}>
                                <div className="use_request_button category-right shadow-button" style={{width:"100%"}} >
                                    <div className="seller_button" >
                                        お問い合わせ
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    {/* <Link to={"/request"} style={{ textDecoration: 'none' }}>
                        <div className="use_request_button category-right" >
                            <div className="seller_button" >
                                リクエストを投稿する
                            </div>
                        </div>
                    </Link> */}
                    {/* <div className="">
                        <div className="">
                            <Link to={"/affiliator-application"} style={{ textDecoration: 'none' }}>
                                <div className="use_request_button category-right" >
                                    <div className="seller_button" >
                                        apply
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div> */}
                </div>
            </div>
        );
    }
}

export { FeedBack };